<table>
    <tr>
        <td colspan="6" style="text-align:center">CITY OF LOS ANGELES OFFICE OF FINANCE</td>
    </tr>
    <tr>
        <td colspan="6" style="text-align:center">
            <hr><br>
        </td>
    </tr>
    <tr>
        <td colspan="4">This is a confirmation receipt for your submitted {{sessionStorage.TRCReceiptType}}.</td>
        <td width="20">&nbsp;</td>
    </tr>
    <tr>
        <td colspan="4">Please keep this receipt for your records.</td>
        <td width="20">&nbsp;</td>
    </tr>
    <tr>
        <td colspan="6"><u><br>TRANSACTION INFORMATION<br></u></td>
    </tr>
    <tr>
        <td colspan="4">Your {{sessionStorage.TRCReceiptType}} was submitted and received on
            {{tRCAppForm.postMarkDt  | date:'MM/dd/yyyy'}}.
        </td>
        <td width="20">&nbsp;</td>
    </tr>
    <tr>
        <td colspan="4">The confirmation number for this transaction is {{tRCAppForm.web_Confirmation_Nbr}}.</td>
        <td width="20">&nbsp;</td>
    </tr>

    <tr>
        <td colspan="6"><u><br>ACCOUNT INFORMATION<br></u></td>
    </tr>
    <tr>
        <td width="40%">Business Account Number:</td>
        <td colspan="5"> {{tRCAppForm.registration_Number}}</td>
    </tr>
    <tr>
        <td width="40%">Legal Name:</td>
        <td colspan="5">{{tRCAppForm.busid_Legal_Nm}}</td>
    </tr>
    <tr>
        <td colspan="6"><u><br>Address:<br></u></td>
    </tr>
    <tr>
        <td colspan="4">{{tRCAppForm.ba1_Str_Nbr}} {{tRCAppForm.ba1_Str_Nbr_Frac}} {{tRCAppForm.ba1_Str_Nm}}
            {{sessionStorage.TRCqBAStreetType}}</td>
    </tr>
    <tr>
        <td colspan="4"> {{tRCAppForm.ba3_City}}, {{tRCAppForm.ba3_State}} {{tRCAppForm.ba3_ZipCd}}</td>
    </tr>
    <tr>
        <td colspan="6"><u><br>NEXT STEPS<br></u></td>
    </tr>
    <tr>
        <td colspan="6">* You will receive your original Tax Registration Certificate, issued by the Director of
            Finance, in the mail. The process can take up to 4 weeks.</td>
    </tr>
    <tr>
        <td colspan="6"> * Please replace the temporary certificate posted at your business location with the original
            certificate once it is received.</td>
    </tr>
    <tr>
        <td colspan="6">* Whenever you contact the Office of Finance, always provide your business account number.</td>
    </tr>
    <ng-container *ngIf= "trcNextSteps?.exemptFormReq">
                <tr>
                    <td colspan="6">
                    * You may qualify for a tax exemption.  After you receive your Tax Registration Certificate in the mail, please
                    call the Tax Exemption Unit at (213)978-3050 during business hours.  Inform them that you are a newly registered
                    taxpayer that may qualify for an exemption, and you are seeking the appropriate exemption forms to submit to their unit.	
               		</td>
        		</tr>
    </ng-container>

    <ng-container *ngIf="trcNextSteps.addlTaxWarning ;else second">
        <tr>
            <td colspan="6">
                * We apologize, but we were
                unable to
                calculate all registration fees for
                your business. If additional taxes are owed, our computer system will automatically open an Underpayment
                or
                Delinquent case and send you a bill for the remaining balance. Please do not be alarmed. This is the
                method used
                by the Office of Finance to track and collect unpaid taxes. Thank you.
            </td>
        </tr>
    </ng-container>
    <ng-template #second>
        <tr>
            <td colspan="6">
                * If this application is not timely or your business started in a prior year, our computer system will
                open
                a case to collect any outstanding liability or missing information. Please do not be alarmed.
                This is the method used by the Office of Finance to track and collect unpaid taxes.
            </td>
        </tr>
    </ng-template>
    <ng-container *ngIf="trcNextSteps.setupPlcMedallionPermit">
        <tr>
            <td colspan="6">* You will need a Police Non-Alarm
                Permit to
                be setup by Office
                of Finance staff. Once you receive your certificate in the mail, please contact us to assist you.
            </td>
        </tr>
    </ng-container>
    <ng-container *ngIf="trcNextSteps.setupTbcPermit">
        <tr>
            <td colspan="6">* You will need a Tobacco Permit to be
                setup by Office
                of Finance staff.
                Once you receive your certificate in the mail, please contact us to assist you.
            </td>
        </tr>
    </ng-container>
    <ng-container *ngIf="trcNextSteps.setupPlcCryWolfPermit">
        <tr>
            <td colspan="6">* Please apply for your Police Alarm
                Permits
                using our Police Alarm
                application website. Please click on the following link:
                {{serverUrl}}/policepermitapp?uAcctNbr={{tRCAppForm.location_Acct_Number}}.
            </td>
        </tr>
    </ng-container>
    <ng-container *ngIf="trcNextSteps.multimediaFormReq">
        <tr>
            <td colspan="6">* Please fill out the required
                Eligibility
                Questionnaire in order to
                determine if you qualify for a limit on the amount of your business taxes. Return the form to Office of
                Finance
                either as an email attachment or by U.S. Mail. Please click on the following link:
                https://finance.lacity.org/sites/g/files/wph1721/files/2021-04/multimedia_questionnaire.pdf. Mailing address can
                be found
                by clicking on the following link: http://finance.lacity.org/contact-us
            </td>
        </tr>
    </ng-container>
    <ng-container *ngIf="trcNextSteps.internetFormReq">
        <tr>
            <td colspan="6">* Please fill out the required Eligibility
                Questionnaire in order to
                properly classify your Internet-Based Business. Return the form to Office of Finance either as an email
                attachment or by U.S. Mail. Please click on the following link:
                http://finance.lacity.org/internet-business-classifications. Mailing address can be found by clicking on
                the
                following link: http://finance.lacity.org/contact-us
            </td>
        </tr>
    </ng-container>
</table>